var map = {
	"./amex.svg": "1206",
	"./bill.svg": "e2b5",
	"./code.svg": "c48c",
	"./fail.svg": "5ccd",
	"./mastercard.svg": "e84a",
	"./success.svg": "4e67",
	"./unionpay.svg": "dcce",
	"./vector.svg": "b75d",
	"./visa.svg": "8bda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c07f";